import React from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from '../helpers/RouteComponentProps';
import { Link } from '../shared/Link';
import { spacing06 } from '../styling/spacing';

type LoggedOutComponent = {
  (props: RouteComponentProps): JSX.Element;
};

export const LoggedOut: LoggedOutComponent = () => (
  <CenteredContainer>
    <div>
      <p>You have been signed out.</p>
      <ReturnToSiteLinkContainer>
        <Link to="/">Return to site</Link>
      </ReturnToSiteLinkContainer>
    </div>
  </CenteredContainer>
);

const CenteredContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const ReturnToSiteLinkContainer = styled.div`
  margin-top: ${spacing06};
`;
